import { result } from "lodash";
import * as api from "./api"

export const definirCantidadEntregada = ({
  id_empresa,
  pedidosAFacturar,
  setDensidad,
  setLtsEntregados,
  setKgsEntregados,
}) => {
  // 1- sumo la cantidad de kg y lts entregados de los pedidos que van a facturarse, independientemente de la unidad de facturacion.
  //La densidad la obtengo del registro en el indice 0 de los pedidos a facturar (que viene del producto). tomo la del indice 0 porque siempre va a ser la misma, ya que pedidosAFacturar SIEMPRE va a estar conformado de pedidos que tengan el mismo producto.
  const densidad =
    id_empresa === 1
      ? pedidosAFacturar[0]?.densidad_hipergas
      : pedidosAFacturar[0]?.densidad_autogas;
  setDensidad(densidad); //Esto lo guardo en un estado porque tambien necesito usarlo por fuera de esta función

  if (pedidosAFacturar.length > 0) {
    const sumatoriaLtsEntregados = pedidosAFacturar.reduce(
      (acumulador, item) => {
        return acumulador + (item.ltsentregados || 0);
      },
      0
    );

    const sumatoriaKgsEntregados = pedidosAFacturar.reduce(
      (acumulador, item) => {
        return acumulador + (item.kgentregados || 0);
      },
      0
    );

    // 2- hago la conversion a las dos unidades de medida porque es necesario, no tanto para la facturacion especial, pero si para los clientes a los que se le factura por su pesada (ya que debo mostrar las dos cosas, kgs y lts)
    const conversionKgALts = parseFloat(
      (sumatoriaKgsEntregados / densidad).toFixed(2)
    );

    const sumatoriaLts = parseFloat(
      (sumatoriaLtsEntregados + conversionKgALts).toFixed(2)
    );

    setLtsEntregados(sumatoriaLts || 0);
    const conversionLtsAKgs = parseFloat(
      (sumatoriaLtsEntregados * densidad).toFixed(2)
    );

    const sumatoriaKgs = parseFloat(
      (sumatoriaKgsEntregados + conversionLtsAKgs).toFixed(2)
    );
    setKgsEntregados(sumatoriaKgs);
  } else {
    setKgsEntregados(0);
    setLtsEntregados(0);
  }
};

export const definirPrecioUnitario = ({
    pedidosAFacturar,
    precio_especial,
    dataCliente,
    unidad_fact,
    setPrecioUnitario
}) => {
    if (pedidosAFacturar?.length > 0) {
      if (precio_especial) {
        api.obtenerPrecioEspecial(
          dataCliente.id,
          unidad_fact,
          setPrecioUnitario
        );
      } else {
        console.log(
          "El cliente NO tiene precio especial. Busco el precio de lista."
        );
        api.obtenerPrecioLista(
          dataCliente,
          pedidosAFacturar,
          unidad_fact,
          setPrecioUnitario
        );
      }
    } else {
      setPrecioUnitario(0);
    }
  };



// const UNIDAD_FACT_LTS = 216;
// const UNIDAD_FACT_KGS = 215;

const UNIDAD_FACT_LTS = 7;
const UNIDAD_FACT_KGS = 2;

const esProductoConvertible = (nombreUm, densidad) => {
  const um = (nombreUm || "").toLowerCase().trim();

  const tieneDensidad = Boolean(densidad && Number(densidad) > 0);

  const esUnidadMasaVolumen = um === "kg" || um === "kgs" || um === "lt" || um === "lts";
  
  const resultado = esUnidadMasaVolumen && tieneDensidad;

  return resultado;
};

export const agruparYConvertirItems = (
  todosLosItems = [],
  idEmpresa,
  densidadesKeyMap,
  unidadMedidaData
) => {

  const densidadKey = densidadesKeyMap.find((d) => d.id_empresa == idEmpresa)?.densidad_col || null

  const defaultUM = {
    id_um_facturacion: 7,
    nombre: "LT",
    config: `{"operacion_densidad":"dividir", "granel_cant_entregada":"ltsentregados"}`,
  };

  const clienteUniFact = unidadMedidaData?.config  ? unidadMedidaData : defaultUM;

  const itemsAConvertir = todosLosItems?.filter((item) =>
    esProductoConvertible(item?.nombre_um, item[densidadKey])
  );
  
  const itemsFijos = todosLosItems.filter(
    (item) => !esProductoConvertible(item.nombre_um, item[densidadKey])
  );

  const convertidosAgrupados = Object.values(
    itemsAConvertir.reduce((acc, curr) => {
      const key = curr.id_producto;    
      if (!key) return acc;

      const densidad = Number(curr[densidadKey] || 1);

      const cantidadOriginal = Number(curr.cantidad || 0);

      let cantidadFinal = cantidadOriginal;

      if(curr.id_um !== clienteUniFact.id_um_facturacion){
        const config = JSON.parse(clienteUniFact.config);

        if(config?.operacion_densidad === "dividir"){
          cantidadFinal = cantidadOriginal / densidad;
        } 

        if(config?.operacion_densidad === "multiplicar"){
          cantidadFinal = cantidadOriginal * densidad;
        } 
      }

      cantidadFinal = parseFloat(cantidadFinal.toFixed(2));

      if (!acc[key]) {
        acc[key] = {
          id_producto: curr.id_producto,
          producto: curr.producto,
          id_um: curr?.id_um,
          // nombre_um: curr?.nombre_um?.toUpperCase(),
          nombre_um: clienteUniFact?.nombre?.toUpperCase(),
          cantidad_total: 0,
          iva: curr.iva,
          iva_cod_afip: curr.iva_cod_afip,
          porc_perc_iva: curr.porc_perc_iva || curr.iva_porc_perc_iva,
          densidad_aplicada: densidad,
          remitos_incluidos: [],
          ids_remitos_incluidos: [],
          valor_iva: curr.valor_iva,
          producto_paga_perc_iva: curr.producto_paga_perc_iva,
          producto_paga_perc_iibb: curr.producto_paga_perc_iibb,
          // descUnidadMedida: curr.descUnidadMedida || curr.nombre_um,
          descUnidadMedida: clienteUniFact.nombre,
          descr_iva:curr.descr_iva,
          ids_pedidos:[]
        };
      }

      acc[key].cantidad_total = parseFloat(
        (acc[key].cantidad_total + cantidadFinal).toFixed(2)
      );

      if (!acc[key].remitos_incluidos.includes(curr.nro)) {
        acc[key].remitos_incluidos.push(curr.nro);
        curr.id_remito && acc[key].ids_remitos_incluidos.push(curr.id_remito);
        curr.id_pedido && acc[key].ids_pedidos.push(curr.id_pedido);
      }

      return acc;
    }, {})
  );

  const fijosAgrupados = Object.values(
    itemsFijos.reduce((acc, curr) => {
      const key = `${curr.id_producto}_${curr.id_um}`;


      if (!acc[key]) {
        acc[key] = {
          id_producto: curr.id_producto,
          producto: curr.producto,
          id_um: curr.id_um,
          nombre_um: curr.nombre_um,
          cantidad_total: 0,
          iva: curr.iva,
          iva_cod_afip: curr.iva_cod_afip,
          porc_perc_iva: curr.porc_perc_iva || curr.iva_porc_perc_iva,
          densidad_aplicada: 0,
          remitos_incluidos: [],
          ids_remitos_incluidos: [],
          valor_iva: curr.valor_iva,
          producto_paga_perc_iva: curr.producto_paga_perc_iva,
          producto_paga_perc_iibb: curr.producto_paga_perc_iibb,
          descUnidadMedida: curr.descUnidadMedida ||curr.nombre_um ,
          descr_iva:curr.descr_iva,
          ids_pedidos:[]
        };
      }

      acc[key].cantidad_total = parseFloat(
        (acc[key].cantidad_total + Number(curr.cantidad || 0)).toFixed(2)
      );

      if (!acc[key].remitos_incluidos.includes(curr.nro)) {
        acc[key].remitos_incluidos.push(curr.nro);
        curr.id_remito && acc[key].ids_remitos_incluidos.push(curr.id_remito);
        curr.id_pedido && acc[key].ids_pedidos.push(curr.id_pedido);
      }
      return acc;
    }, {})
  );

  return [...convertidosAgrupados, ...fijosAgrupados];
};

export const armarItems=(remitos, densidadesKeyMap, idEmpresa, umData)=>{
  const densidadKey= densidadesKeyMap?.find(dens=>dens.id_empresa === idEmpresa).densidad_col

  const itemsForm = remitos.map(pedido=> {
    const cantidad = getCantidadEntregada(pedido, densidadKey, umData);

    return {
      id_producto:pedido?.id_producto,
      producto:pedido.detalle_factura,
      id_um:umData.id_um_facturacion,
      densidad_autogas:pedido?.densidad_autogas,
      densidad_hipergas:pedido?.densidad_hipergas,
      cantidad:cantidad,
      iva:pedido?.descr_porc_iva,
      iva_cod_afip:pedido.iva_cod_afip,
      porc_perc_iva:pedido?.porc_perc_iva,
      precio_x_kg:"",
      precio_x_lt:"",
      densidad_aplicada:pedido[densidadKey],
      remitos_incluidos:[pedido.nro_remito],
      valor_iva:pedido?.valor_iva,
      producto_paga_perc_iva: pedido?.producto_paga_perc_iva,
      producto_paga_perc_iibb:pedido?.producto_paga_perc_iibb,
      nombre_um:umData.nombre,
      descr_iva:pedido?.descr_porc_iva,
      nro:pedido.nro_remito,
      id_remito:null,
      id_pedido:pedido?.id
    }
  })

  // console.log(cantidad)

  return itemsForm;
}

const getCantidadEntregada = (pedido, densidadKey, umData) =>{
  if (!umData?.config) return pedido?.cantidad || 0;

  const config = typeof umData.config === 'string' 
    ? JSON.parse(umData.config) 
    : umData.config;


  const campoUmCliente = config.granel_cant_entregada;

  if (pedido[campoUmCliente]) {
    return pedido[campoUmCliente]
  };

  const densidad = pedido[densidadKey];

  if (!densidad || densidad <= 0) return 0; // Prevenimos división por cero o valores inválidos

  if (config.operacion_densidad === 'dividir') {
    return (pedido.kgentregados || 0) / densidad;
  }

  if (config.operacion_densidad === 'multiplicar') {
    return (pedido.ltsentregados || 0) * densidad;
  }

  return 0;
}

export const dePedidoARemito = (allRemitosPedidos, id_empresa, id_tipocliente) => {

  const pedidosToRemitos = allRemitosPedidos
  .filter((remitos) => !!remitos.id_pedido)
  .map((pedido) => {
    return {
      id_remito: null,
      id_pedido:pedido?.id_pedido,
      estado: "A Facturar",
      fecha: pedido?.fecha_real_entrega,
      id_chofer: "",
      id_cliente: pedido?.id_cliente,
      id_direccion_entrega: pedido?.id_direccionentrega,
      id_empresa: id_empresa, //Es la empresa del cliente.
      id_estado: pedido?.id_estado, //dudoso, no creo que este valor sea el que corresponda.
      id_sucursal_remite: pedido?.idsucursal_atiende,
      id_tipo_cliente: id_tipocliente,
      razon_social: pedido.razon_social,
      id_provincia: pedido.id_provincia,
      items: [
        {
          iva: pedido.iva,
          id_um: pedido?.item_id_um_facturacion, //dudoso comportamiento.
          cantidad: pedido?.kgentregados || pedido?.ltsentregados,
          producto: pedido?.detalle_factura,
          descr_iva: pedido?.iva,
          id_remito: null,
          nombre_um: pedido?.item_um_abrev,
          valor_iva: pedido?.valor_iva,
          id_producto: pedido?.id_producto,
          iva_cod_afip: pedido?.iva_cod_afip,
          porc_perc_iva: pedido?.porc_perc_iva,
          densidad_autogas: pedido?.densidad_autogas,
          descUnidadMedida: pedido?.item_um_nombre,
          densidad_hipergas: pedido?.densidad_hipergas,
          producto_paga_perc_iva: pedido?.producto_paga_perc_iva,
          producto_paga_perc_iibb: pedido?.producto_paga_perc_iibb,
        },
      ],
      nro: pedido?.nro_remito,
      sucursal: pedido?.sucursal_atiende,
    };
  });

  // const allRemitos = [...regsRemitos, ...pedidosToRemitos]

  return pedidosToRemitos;

}

// Convierte los renglones de pedidos de envasado (endpoint renglonesremitos) a la
// misma forma de "remito con items" que consume NuevaFacturacion, agrupando por id_pedido.
export const deEnvasadoPedidoARemito = (renglones = [], id_empresa) => {
  const porPedido = renglones
    .filter((r) => !!r.id_pedido)
    .reduce((acc, r) => {
      const key = r.id_pedido;
      // console.log("R",r);
      
      if (!acc[key]) {
        acc[key] = {
          id_remito: null,
          id_pedido: r.id_pedido,
          estado: "A Facturar",
          fecha: r.fecha_para,
          id_chofer: "",
          id_cliente: r.id_cliente,
          id_direccion_entrega: r.id_direccion,
          id_empresa: id_empresa ?? r.id_empresa,
          id_estado: r.estado,
          id_sucursal_remite: null,
          id_tipo_cliente: null,
          items: [],
          nro: r.remito_entrega,
          sucursal: r.sucursal,
          razon_social: r.razon_social,
        };
      }

      acc[key].items.push({
        iva: r.valor_facturacion,
        id_um: r.id_um ?? null,
        cantidad: r.cantidad,
        producto: r.detalle_factura || r.nombre_producto,
        descr_iva: r.descr_iva,
        id_remito: null,
        id_pedido: r.id_pedido,
        nombre_um: r.nombre_um || "UN",
        valor_iva: r.valor_iva,
        id_producto: r.producto,
        iva_cod_afip: r.iva_cod_afip,
        porc_perc_iva: r.porc_perc_iva,
        densidad_autogas: r.densidad_autogas,
        descUnidadMedida: r.descUnidadMedida || r.nombre_um || "UN",
        densidad_hipergas: r.densidad_hipergas,
        producto_paga_perc_iva: r.producto_paga_perc_iva,
        producto_paga_perc_iibb: r.producto_paga_perc_iibb,
        nro: r.remito_entrega,
      });

      return acc;
    }, {});

  return Object.values(porPedido);
};